import { LocalStop } from './local-stop.model';
import * as moment from 'moment';
import { LocalImport } from './local-import.model';
import { LocalLoadEvent } from './local-load-event.model';
import { LocalLoadCommunication } from './local-load-communication.model';
import { LocalLoadDocument, LocalLoadDocumentType } from './local-load-document.model';
import { LocalNote } from './local-note.model';
import { Moment } from 'moment';

export class LocalLoad {

  public id: string;
  public loadUuid: string;
  public loadId: string;
  public loadNumber: string;
  public createdAt: Moment;
  public updatedAt: Moment;
  public completedAt: Moment;
  public localLoadImport: LocalImport;
  public vehicle: string;
  public status: LocalLoadStatus;
  public plannedStart: Moment;
  public stops: LocalStop[]             = [];
  public events: LocalLoadEvent[]       = [];
  public documents: LocalLoadDocument[] = [];
  public communication: LocalLoadCommunication;
  public position: number;

  public expanded   = false;
  public shipmentNumbers: string;
  public salesOrderNumber: string[];
  public isSelected = false;
  public firstLocalStop: LocalStop;
  public lastLocalStop: LocalStop;

  static fromDto(l): LocalLoad {
    const load = new LocalLoad();

    if (!l) {
      return null;
    }

    const plannedStopsDates = l.stops
      .filter(s => !!s.planned_arrival)
      .map(s => moment(s.planned_arrival));

    const plannedStart = plannedStopsDates.length > 0 ?
      plannedStopsDates.reduce((v1, v2) => v1.isBefore(v2) ? v1 : v2)
      :
      null;

    load.id              = l.id;
    load.loadUuid        = l.load_uuid;
    load.loadId          = l.load_id;
    load.loadNumber      = l.load_number;
    load.createdAt       = l.created_at ? moment(l.created_at) : null;
    load.updatedAt       = l.updated_at ? moment(l.updated_at) : null;
    load.completedAt     = l.completed_at ? moment(l.completed_at) : null;
    load.localLoadImport = LocalImport.fromDto(l.local_load_import);
    load.vehicle         = l.vehicle;
    load.status          = l.status;
    load.plannedStart    = plannedStart;
    load.stops           = l.stops.map(stop => LocalStop.fromDto(stop));
    load.position        = l.position;

    load.shipmentNumbers = load.stops.map(s => s.shipments)
      .reduce((s1, s2) => s1.concat(s2))
      .map(s => `#${s.shipmentNumber}`)
      .filter((s, index, self) => self.indexOf(s) === index)
      .join(', ');
    load.salesOrderNumber = load.stops.map(s => s.shipments)
      .reduce((s1, s2) => s1.concat(s2))
      .map(s => s.salesOrderNumber)
      .filter((s, index, self) => self.indexOf(s) === index);
    load.firstLocalStop  = LocalStop.fromDto(l.first_local_stop);
    load.lastLocalStop   = LocalStop.fromDto(l.last_local_stop);

    return load;
  }

  expand() {
    this.expanded = !this.expanded;
  }

  selectItem() {
    this.isSelected = !this.isSelected;
  }

  mergePicturesIntoNotes() {
    this.documents.filter(d => d.type === LocalLoadDocumentType.PICTURE)
      .map(p => {
        const pictureAsNote = new LocalNote();

        pictureAsNote.id        = p.id;
        pictureAsNote.createdAt = p.uploadedAt;
        pictureAsNote.createdBy = p.uploadedBy;
        pictureAsNote.isPicture = true;

        return pictureAsNote;
      })
      .forEach(p => this.communication.notes.push(p));

    this.communication.sortNotes();
  }

  updateShipmentsPod() {
    this.stops.map(s => s.shipments)
      .reduce((s1, s2) => s1.concat(s2))
      .forEach(s => s.pod = this.getLastPodForShipment(s.shipmentNumber));
  }

  getLastPodForShipment(shipmentNumber: string): LocalLoadDocument {
    const matches: LocalLoadDocument[] = this.documents
      .filter(d => d.type === LocalLoadDocumentType.POD)
      .filter(d => d.shipmentNumber === shipmentNumber);

    if (matches.length === 0) {
      return null;
    } else {
      return matches.reduce((d1, d2) => d1.uploadedAt.isAfter(d2.uploadedAt) ? d1 : d2);
    }
  }
}

export enum LocalLoadStatus {
  PLANNED   = 'PLANNED',
  ON_GOING  = 'ON_GOING',
  COMPLETED = 'COMPLETED'
}
